import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Search, Filter, PlayCircle, Clock, ShieldCheck, FolderKanban, Users, BarChart3, FileText, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { AgencyModal } from './AgencyModal';
import { motion } from 'framer-motion';
export const Audiences = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-149" data-mp="2kkg9vrzs0bcz">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-150" data-mp="2klhx0uu2gob2" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151" data-mp="25w287ke3isy0">
        {/* Why Work with Talent Agencies */}
        <div className="mb-32" data-id="element-152" data-mp="2atu40phv2z7h">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-center" data-id="element-153" data-mp="2auwrenfz6jin">
            <div className="w-full lg:w-1/2" data-id="element-154" data-mp="1ww5e338xt1vk">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-155" data-mp="20wfw5ea07iqs">
                Why work with talent agencies?
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-156" data-mp="2d2ye78q7ldz3">
                Get fast responses and more reliable relationships you can count
                on. Talent managers on Zano actively manage their rosters and
                respond directly to brand inquiries — faster, professional
                responses from the people who know their influencers best.
              </p>
              <p className="text-base text-gray-600 mb-6" data-id="element-157" data-mp="1ucqk1g4hlxv1">
                Not only do they give you access to the industry's top creators,
                they're business people who understand your goals and needs.
                Their job is to sell their influencers. The influencers' job is
                to work on their content. You get the best of the best and talk
                directly to who handles it.
              </p>
              <p className="text-base text-gray-700 font-medium mb-6" data-id="element-158" data-mp="1bl7i7cm78pul">
                The Talent Agency Directory lists all 400+ talent agencies on
                Zano with their main point of contact, website, and total roster
                following.
              </p>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-6 flex items-start gap-3" data-id="element-159" data-mp="20cd2zazaiyk3">
                <div className="p-1.5 bg-white rounded-md shadow-sm shrink-0" data-id="element-160" data-mp="255fyvprjik3g">
                  <Lock size={14} className="text-gray-500" data-id="element-161" data-mp="2a3hgs7d8cddc" />
                </div>
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-162" data-mp="1dd8jesnrtdqn">
                  <span className="font-semibold text-gray-900" data-id="element-163" data-mp="1df1o42etpnw0">
                    Approved access required.
                  </span>{' '}
                  Anyone can post a casting call to our network of agencies, but
                  viewing the premium roster database and talent agency
                  directory requires an approved brand account.
                </p>
              </div>
              <Link to="/pricing" data-id="element-164" data-mp="2xuwn0b84netv">
                <Button variant="primary" data-id="element-165" data-mp="32rdn83slpjnb">Start Free Trial</Button>
              </Link>
            </div>

            <div className="w-full lg:w-1/2" data-id="element-166" data-mp="r536nfo5kq7b">
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-167" data-mp="r3rxt1fuos9c">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-168" data-mp="m68lw86mkrkk">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-169" data-mp="hcx9zsmyhkls">
                    <div className="flex items-center gap-2" data-id="element-170" data-mp="cdt3xavbw2zo">
                      <Users size={16} className="text-gray-500" data-id="element-171" data-mp="8etqt2zg0zx5" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-172" data-mp="3efsicnn94cb">
                        Talent Agency Directory
                      </span>
                    </div>
                    <Badge className="bg-purple-100 text-purple-800 border border-purple-200" data-id="element-173" data-mp="3pm72jtz7e34f">
                      400+ Agencies
                    </Badge>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-174" data-mp="1srsys7fbh2g2">
                    <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-175" data-mp="1nvvmqdb36i93">
                      <thead className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase" data-id="element-176" data-mp="1vv8m4g9x2ge3">
                        <tr data-id="element-177" data-mp="20tjyaxnop2zh">
                          <th className="px-4 py-3 font-medium" data-id="element-178" data-mp="20ttn4hwzt43l">Agency</th>
                          <th className="px-4 py-3 font-medium" data-id="element-179" data-mp="1lwj2oj2dgnvq">Main POC</th>
                          <th className="px-4 py-3 font-medium" data-id="element-180" data-mp="1qvvxpr3ed19e">Website</th>
                          <th className="px-4 py-3 font-medium" data-id="element-181" data-mp="1d50p8fwt8m6c">
                            Total Following
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-182" data-mp="136upa3ukdq44">
                        <tr data-id="element-183" data-mp="138nwpld04ed6">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-184" data-mp="185xjet90abxb">
                            Clicks Talent
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-185" data-mp="u7fx8zyr17hi">
                            John Marcus
                          </td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-186" data-mp="y9koxt5mzu1i">
                            clickstalent.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-187" data-mp="am7cz11n3okc">
                            14.2M
                          </td>
                        </tr>
                        <tr data-id="element-188" data-mp="jjzsa57d2w7q">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-189" data-mp="jjq3gky1yv3m">
                            Viral Nation
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-190" data-mp="tjqqohz1lvd3">Ena</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-191" data-mp="17am1hzt3qmjb">
                            viralnation.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-192" data-mp="139tpwzwrc5jv">
                            28.5M
                          </td>
                        </tr>
                        <tr data-id="element-193" data-mp="1carpn605xqwn">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-194" data-mp="1c7lw9eki42v4">
                            Boost Society
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-195" data-mp="dx48v0wliqvl">Josh</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-196" data-mp="iwyvutd92wbd">
                            boost-society.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-197" data-mp="nps4hsbuaosq">
                            8.1M
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* For Talent Agencies */}
        <div className="bg-gray-900 text-white rounded-3xl p-8 lg:p-12 -mx-4 sm:mx-0" data-id="element-198" data-mp="16l9q3dofxxqo">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-199" data-mp="33fwh9m22tm4h">
            <div className="w-full lg:w-1/2" data-id="element-200" data-mp="38defoiigwiy8">
              <Badge className="mb-4 bg-gray-800 text-gray-300 border border-gray-700" data-id="element-201" data-mp="38e6e013g8us7">
                For Talent Agencies
              </Badge>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-202" data-mp="2w3yigrn9x3rz">
                Turn every creator into a live, bookable asset
              </h2>
              <p className="text-lg text-gray-400 mb-6" data-id="element-203" data-mp="2r553svw936q8">
                Showcase your roster, maintain living media kits, and receive
                qualified campaign opportunities from brands.
              </p>
              <div className="grid grid-cols-1 gap-4 mb-8" data-id="element-204" data-mp="3jr6pbe0cokw4">
                {['Roster management — manage your roster internally with live performance data in one clean, easy-to-scan table', 'Get your influencers deals from brands/marketing agencies on Zano', 'Get live public media kits you can share externally', 'Submit influencers to exclusive casting calls'].map((item, idx) => <div key={idx} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-205" data-mp="1ucruqd2ni3sp" data-mpi={idx}>
                    <CheckCircle2 size={18} className="text-zano-pink shrink-0 mt-0.5" data-id="element-206" data-mp="2cjtb97eulwn" />
                    <span data-id="element-207" data-mp="3kjzj3euirmdt">{item}</span>
                  </div>)}
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-4 mb-4" data-id="element-208" data-mp="3pi16ud2w49vm">
                <Link to="/list-your-roster" className="w-full sm:w-auto" data-id="element-209" data-mp="h2ze4mvwzrua">
                  <Button variant="secondary" className="w-full sm:w-auto border-gray-700 text-white hover:bg-gray-800" data-id="element-210" data-mp="l3ja3n4r4peu">
                    Learn More
                  </Button>
                </Link>
                <Button variant="primary" className="w-full sm:w-auto" onClick={() => setIsModalOpen(true)} data-id="element-211" data-mp="c8msc66yu4fd">
                  List Your Agency
                </Button>
              </div>
              <p className="text-sm text-gray-400" data-id="element-212" data-mp="1e4rh1c40lpx9">
                Want to see how it works?{' '}
                <a href="https://www.youtube.com/watch?v=d0T7ZbxsxrY" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:text-zano-pinkDark font-medium underline underline-offset-2 inline-flex items-center gap-1" data-id="element-213" data-mp="1a3pealaw2vqj">
                  <PlayCircle size={15} data-id="element-214" data-mp="v9as6bw1367n" /> Watch a demo video
                </a>
              </p>
            </div>

            <div className="w-full lg:w-1/2 relative" data-id="element-215" data-mp="r7zcay2yhzcn">
              {/* Product UI Mockup: Talent Agency Roster Dashboard with Profile Header Layer */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-216" data-mp="105jdy84qdxns">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-217" data-mp="2gjhuj5o29p83">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-218" data-mp="2bkohfecos08g">
                    <div className="flex items-center gap-2" data-id="element-219" data-mp="1leublxca4oqb">
                      <Users size={16} className="text-gray-500" data-id="element-220" data-mp="1gg0yw74th1r7" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-221" data-mp="1bpkmmqcqfm6f">
                        My Roster
                      </span>
                    </div>
                    <Button variant="primary" className="text-xs px-3 py-1.5 h-auto" data-id="element-222" data-mp="16py72a9fltug">
                      + Add creator
                    </Button>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-223" data-mp="sqq91kp08rru">
                    <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-224" data-mp="sr8acvqixw6m">
                      <thead className="bg-gray-50 border-b border-gray-100 text-gray-500 uppercase" data-id="element-225" data-mp="nsx2gqjshvr1">
                        <tr data-id="element-226" data-mp="2n3g2y2fdi0z8">
                          <th className="px-4 py-3 font-medium" data-id="element-227" data-mp="2n2n19fv9u1ny">Name</th>
                          <th className="px-4 py-3 font-medium" data-id="element-228" data-mp="2i6xwmy4e9uks">Category</th>
                          <th className="px-4 py-3 font-medium" data-id="element-229" data-mp="2qngh0md6xtqm">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1248.png" alt="TikTok" className="w-3 h-3 inline-block" data-id="element-230" data-mp="2uo8qngpz60nf" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-231" data-mp="27ob0bxfhxqbu">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1249.png" alt="Instagram" className="w-3 h-3 inline-block" data-id="element-232" data-mp="27q5kvamuvgfe" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-233" data-mp="3s45tdpm4cn1s">
                            <svg className="w-3.5 h-3.5 inline-block text-[#FF0000]" viewBox="0 0 24 24" fill="currentColor" aria-label="YouTube" data-id="element-234" data-mp="3s5qslsjdou5z">
                              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-235" data-mp="32hl96jy4ctmx" />
                            </svg>
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-236" data-mp="2yeyor43s2azr">Status</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-237" data-mp="2tlvuetr6exii">
                        <tr className="hover:bg-gray-50" data-id="element-238" data-mp="25wkpr16pgiz3">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-239" data-mp="20yj4c9lt47kg">
                            <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-240" data-mp="20wf5i62rlyr1" />
                            <span className="font-medium text-gray-900" data-id="element-241" data-mp="bhdw4xbr3wq7">
                              Elena Rodriguez
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-242" data-mp="z4vujbpitt25">Fashion</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-243" data-mp="145jj7qqa1xt7">1.2M</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-244" data-mp="q58pmfxl254c">340K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-245" data-mp="u7cdy55cp471">-</td>
                          <td className="px-4 py-3" data-id="element-246" data-mp="u9q6o7ck64bf">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-247" data-mp="3avga2g6u9hhm">
                              Live
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-248" data-mp="3qeivcdm3hxup">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-249" data-mp="3qcy0emvvccwb">
                            <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-250" data-mp="3lghcntsl00jr" />
                            <span className="font-medium text-gray-900" data-id="element-251" data-mp="d05qxstm10in">
                              Marcus Chen
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-252" data-mp="3xwhl6a2vd6u">Tech</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-253" data-mp="2sqiffb48gx40">850K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-254" data-mp="2sofjybkbabrw">120K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-255" data-mp="2onvm15rwz44p">2.1M</td>
                          <td className="px-4 py-3" data-id="element-256" data-mp="1485vrcoqojom">
                            <Badge className="bg-orange-50 text-orange-700 border border-orange-200 text-[10px] px-2 py-0.5" data-id="element-257" data-mp="188psif5ehla8">
                              Action Required
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-258" data-mp="1i0425fr2g1h3">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-259" data-mp="1my5kfygo3wri">
                            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-260" data-mp="1rwp3nr3vmug6" />
                            <span className="font-medium text-gray-900" data-id="element-261" data-mp="1kt1kdu2nk6y">
                              Sarah Jenkins
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-262" data-mp="19u078ldscin9">Lifestyle</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-263" data-mp="19w4k3stnwrzo">450K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-264" data-mp="14wrpun0goin2">890K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-265" data-mp="1iw11d9dq2okp">-</td>
                          <td className="px-4 py-3" data-id="element-266" data-mp="1dw4wz9144v4m">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-267" data-mp="1duk2fjestc6r">
                              Live
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Floating Profile Header Layer */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="absolute -bottom-6 -right-4 sm:-right-8 w-80 bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-4 z-20" data-id="element-268" data-mp="1xm8dl7d4zbcy">
                <div className="flex items-center gap-3" data-id="element-269" data-mp="27fuqxm4xxhd6">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64" alt="Elena Rodriguez" className="w-12 h-12 rounded-full object-cover shrink-0" data-id="element-270" data-mp="27e9vzveprwes" />
                  <div className="min-w-0" data-id="element-271" data-mp="22ht54tg4r3y0">
                    <h4 className="text-sm font-bold text-gray-900 leading-tight" data-id="element-272" data-mp="22ef3xoj7d0s5">
                      Elena Rodriguez
                    </h4>
                    <p className="text-xs font-medium text-gray-700" data-id="element-273" data-mp="1sitythiu7ke6">
                      ABC Talent Agency
                    </p>
                    <span className="inline-flex items-center gap-1 mt-0.5 text-[10px] font-semibold text-emerald-600" data-id="element-274" data-mp="28xbhkgpfzbdz">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-275" data-mp="23x5msrnvl8ro" />
                      Exclusive
                    </span>
                    <p className="text-[11px] text-gray-500 mt-0.5 truncate" data-id="element-276" data-mp="1u1lqw59baa2x">
                      john.smith@abctalent.com
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};